function getStoreIdWithoutVersion(id) {
    var _a;
    return id.substring(0, (_a = id === null || id === void 0 ? void 0 : id.match(/V\d+/)) === null || _a === void 0 ? void 0 : _a.index); // removes versions (storeNameV1 -> storeName)
}
export default getStoreIdWithoutVersion;
